/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import Settings from '../components/Settings';
import house from '../assets/icons/house-door.svg';
import pfeil from '../assets/icons/Pfeil.svg';
import img1 from '../assets/images/overview/Bildmotiv-11.jpg';
import img2 from '../assets/images/overview/Bildmotiv-10.jpg';
import img3 from '../assets/images/overview/Bildmotiv-9.jpg';
import img4 from '../assets/images/overview/Bildmotiv-8.jpg';
import img5 from '../assets/images/overview/Bildmotiv-7.jpg';
import img6 from '../assets/images/overview/Bildmotiv-6.jpg';
import img7 from '../assets/images/overview/Bildmotiv-5.jpg';
import img8 from '../assets/images/overview/Bildmotiv-4.jpg';
import img9 from '../assets/images/overview/Bildmotiv-3.jpg';
import img10 from '../assets/images/overview/Bildmotiv-2.jpg';
import img11 from '../assets/images/overview/Bildmotiv-1.jpg';
import img12 from '../assets/images/overview/Bildmotiv.jpg';
import img13 from '../assets/images/overview/AdobeStock_409877652.jpg';
import img14 from '../assets/images/overview/AdobeStock_75313743.jpg';

import step1 from '../assets/images/overview/step-1-grafik.svg';
import step2 from '../assets/images/overview/step-2-grafik-01.svg';
import step3 from '../assets/images/overview/step-3-grafik.png';
import step4 from '../assets/images/overview/step-4-grafik.png';

const Homepage = () => {
  return (
    <div id='overview'>
      {/* HEAD */}

      {/* NAV */}
      <Navbar />
      {/* sub nav */}
      <div
        id='sub-nav'
        className='container-xxl d-none d-md-block mb-3 mt-4'
        style={{ fontSize: 12 }}>
        <div className='d-flex align-content-center' style={{ gap: '0.5rem' }}>
          <a>
            {' '}
            <img src={house} alt='' style={{ width: 14 }} />
          </a>
          <span>»</span>
          <a>Ratgeber</a>
        </div>
      </div>
      {/* HERO  */}
      <section className='container-xxl px-0 px-xxl-0' id='hero-ratgeber'>
        <div className='banner'>
          <div>
            <h1 className='mb-2'>Ratgeber</h1>
          </div>
        </div>
      </section>
      {/* wissenswertes */}
      <section className='container px-4 px-lg-4 px-xxl-0 py-10' id='wissenswertes'>
        <div className='title'>
          <h2>Wissenswertes zur Pflege</h2>
          <h5>Hinweis</h5>
          <p>
            Alle Informationen auf dieser Seite sind ohne Gewähr, da sie gesetzlichen Änderungen
            unterliegen.
          </p>
          <p>
            Die aktuellsten Gesetze und Informationen zum Thema Pflege beim Bundesministerium für
            Gesundheit finden Sie{' '}
            <span>
              <a href='#'>hier »</a>
            </span>
          </p>
        </div>
        <div className='cards py-5'>
          <div className='row gy-5 gx-5 gx-xl-3 gy-xl-3 gy-xxl-4 gx-xxl-4 px-3 px-lg-0'>
            <div className='col-12 col-md-6 col-xl-3 setcard'>
              <div className=''>
                <div className=''>
                  <img src={img1} alt='mundschutz' />
                </div>
                <div className='pt-2 pb-4 px-2 px-md-5 px-md-2 px-xxl-5 pt-3'>
                  <h3>
                    <a href='#'>Mehr über Pflegehilfsmittel gratis</a>
                  </h3>
                </div>
              </div>
            </div>
            <div className='col-12 col-md-6 col-xl-3 setcard'>
              <div className=''>
                <div className=''>
                  <img src={img2} alt='mundschutz' />
                </div>
                <div className='pt-2 pb-4 px-5 px-md-2 px-xxl-5 pt-3'>
                  <h3>
                    <a href='#'>Mehr über Pflegehilfsmittel beantragen</a>
                  </h3>
                </div>
              </div>
            </div>
            <div className='col-12 col-md-6 col-xl-3 setcard'>
              <div>
                <div className=''>
                  <img src={img3} alt='mundschutz' />
                </div>
                <div className='pt-2 pb-4 px-5 px-md-2 px-xxl-5 pt-3'>
                  <h3>
                    <a href='#'>Mehr über Pflegehilfsmittelpauschale</a>
                  </h3>
                </div>
              </div>
            </div>
            <div className='col-12 col-md-6 col-xl-3 setcard'>
              <div>
                <div className=''>
                  <img src={img4} alt='mundschutz' />
                </div>
                <div className='pt-2 pb-4 px-5 px-md-2 px-xxl-5 pt-3'>
                  <h3>
                    <a href='#'>Wie kann man Pflegehilfsmittel bestellen</a>
                  </h3>
                </div>
              </div>
            </div>
            <div className='col-12 col-md-6 col-xl-3 setcard'>
              <div>
                <div className=''>
                  <img src={img5} alt='mundschutz' />
                </div>
                <div className='pt-2 pb-4 px-5 px-md-2 px-xxl-5 pt-3'>
                  <h3>
                    <a href='#'>Mehr über den Pflegehilfsmittelkatalog</a>
                  </h3>
                </div>
              </div>
            </div>
            <div className='col-12 col-md-6 col-xl-3 setcard'>
              <div>
                <div className=''>
                  <img src={img6} alt='mundschutz' />
                </div>
                <div className='pt-2 pb-4 px-5 px-md-2 px-xxl-5 pt-3'>
                  <h3>
                    <a href='#'>Mehr über die Pflegehilfsmittel-Liste</a>
                  </h3>
                </div>
              </div>
            </div>
            <div className='col-12 col-md-6 col-xl-3 setcard'>
              <div>
                <div className=''>
                  <img src={img7} alt='mundschutz' />
                </div>
                <div className='pt-2 pb-4 px-5 px-md-2 px-xxl-5 pt-3'>
                  <h3>
                    <a href='#'>Mehr über das Pflegehilfsmittelverzeichnis</a>
                  </h3>
                </div>
              </div>
            </div>
            <div className='col-12 col-md-6 col-xl-3 setcard'>
              <div>
                <div className=''>
                  <img src={img8} alt='mundschutz' />
                </div>
                <div className='pt-2 pb-4 px-5 px-md-2 px-xxl-5 pt-3'>
                  <h3>
                    <a href='#'>Mehr über die Grundpflege</a>
                  </h3>
                </div>
              </div>
            </div>
            <div className='col-12 col-md-6 col-xl-3 setcard'>
              <div>
                <div className=''>
                  <img src={img9} alt='mundschutz' />
                </div>
                <div className='pt-2 pb-4 px-5 px-md-2 px-xxl-5 pt-3'>
                  <h3>
                    <a href='#'>Mehr über den Antrag auf Pflegehilfsmittel</a>
                  </h3>
                </div>
              </div>
            </div>
            <div className='col-12 col-md-6 col-xl-3 setcard'>
              <div>
                <div className=''>
                  <img src={img10} alt='mundschutz' />
                </div>
                <div className='pt-2 pb-4 px-5 px-md-2 px-xxl-5 pt-3'>
                  <h3>
                    <a href='#'>Mehr über die Pflegekasse</a>
                  </h3>
                </div>
              </div>
            </div>
            <div className='col-12 col-md-6 col-xl-3 setcard'>
              <div>
                <div className=''>
                  <img src={img11} alt='mundschutz' />
                </div>
                <div className='pt-2 pb-4 px-5 px-md-2 px-xxl-5 pt-3'>
                  <h3>
                    <a href='#'>Mehr über den Standard für Inkontinenz</a>
                  </h3>
                </div>
              </div>
            </div>
            <div className='col-12 col-md-6 col-xl-3 setcard'>
              <div>
                <div className=''>
                  <img src={img12} alt='mundschutz' />
                </div>
                <div className='pt-2 pb-4 px-5 px-md-2 px-xxl-5 pt-3'>
                  <h3>
                    <a href='#'>Mehr über die Pflege bei Angehörigen</a>
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='articles py-5'>
          <div className='row gy-5'>
            <div className='col-12 col-xl-6 d-flex flex-column article'>
              <div>
                <img src={img13} alt='' className='img-article' />
              </div>
              <div
                className='d-flex flex-column justify-content-between'
                style={{ height: '100%' }}>
                <div>
                  <h3 className='py-3'>Häusliche Pflege</h3>
                  <p className='mb-3 mb-xxl-5'>
                    Gestalten sich die körperlichen und geistigen Einschränkungen schwerwiegender,
                    muss über Hilfeleistungen durch die Pflegekasse und die Beantragung eines
                    Pflegegrades nachgedacht werden. Im Folgenden fassen wir Ihnen die wichtigsten
                    Informationen über die häusliche Pflege zusammen und gehen auch auf die
                    Absicherung der Angehörigen ein, wenn diese die Pflege im eigenen Heim selbst
                    übernehmen möchten.
                  </p>
                </div>
                <a href='#'>
                  Mehr über die häusliche Pflege
                  <span className='ms-2'>
                    <img src={pfeil} alt='' />
                  </span>
                </a>
              </div>
            </div>
            <div className='col-12 col-xl-6 d-flex flex-column article'>
              <div>
                <img src={img14} alt='' className='img-article' />
              </div>
              <div
                className='d-flex flex-column justify-content-between'
                style={{ height: '100%' }}>
                <div>
                  <h3 className='py-3'>Pflegehilfe</h3>
                  <p className='mb-3 mb-xxl-5'>
                    Die Pflegebedürftigkeit eines Angehörigen kann in manchen Fällen plötzlich und
                    unerwartet eintreten. Nach einem Unfall oder einer schweren Krankheit kann ein
                    Betroffener häufig den Alltag nicht mehr allein bewerkstelligen. Pflegende
                    Angehörige benötigen nun schnellstmöglich Unterstützung und müssen sich um
                    Pflegehilfe kümmern.
                  </p>
                </div>
                <a href='#'>
                  Mehr über die Pflegehilfe
                  <span className='ms-2'>
                    <img src={pfeil} alt='' />
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* pflegen */}
      <section id='pflegen' className='py-5' style={{ position: 'relative' }}>
        <div className='container-xxl px-0'>
          <div className='container-xxl px-3 px-xl-5 px-xxl-0'>
            <div className='my-5 title'>
              <h2>
                Sie pflegen einen Angehörigen zu Hause oder sind selbst pflegebedürftig? Sichern Sie
                sich das PflegehilfeSet im Wert von 40,- Euro?!
              </h2>
              <p className='my-2'>So bekommen Sie Ihr kostenfreies PflegehilfeSet nach Hause.</p>
            </div>
            <div>
              <div className='row gy-5 gx-2 px-3 px-lg-0'>
                <div className='col-12 col-md-6 col-xl-3 d-flex flex-column'>
                  <div>
                    <img src={step1} alt='step1' />
                  </div>
                  <div>
                    <h3>Bestellung</h3>
                    <p>
                      Wählen Sie die benötigten Produkte aus und konfigurieren Sie Ihr individuelles
                      Set im Wert von 40 €. Wir stehen Ihnen auf allen Kommunikationswegen für die
                      Bestellung zur Verfügung.
                    </p>
                  </div>
                </div>
                <div className='col-12 col-md-6 col-xl-3 d-flex flex-column'>
                  <div>
                    <img src={step2} alt='step2' style={{ height: '100%' }} />
                  </div>
                  <div>
                    <h3>Lieferung</h3>
                    <p>
                      In der Regel erhalten Sie Ihre Bestellung kürzester Zeit direkt nach Hause
                      bzw. zum gewünschten Einsatzort.
                    </p>
                  </div>
                </div>
                <div className='col-12 col-md-6 col-xl-3 d-flex flex-column'>
                  <div>
                    <img src={step3} alt='step3' />
                  </div>
                  <div>
                    <h3>Beantragung</h3>
                    <p>
                      Schon nach Abschluss Ihrer Bestellung leiten wir für Sie die Beantragung und
                      Abrechnung bei der Pflegekasse ein. Sie brauchen sich um nichts kümmern.
                    </p>
                  </div>
                </div>
                <div className='col-12 col-md-6 col-xl-3 d-flex flex-column'>
                  <div>
                    <img src={step4} alt='step4' />
                  </div>
                  <div>
                    <h3>Abwicklung</h3>
                    <p>
                      Sie erhalten monatlich Ihr PflegehilfeSet, das Sie bequem an Ihre Bedürfnisse
                      anpassen können. Es gibt keine versteckten Kosten und keine Vertragsbindung -
                      nur volle Flexibilität für Sie.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className='article-btn'>
              <button className='btn-primary mt-5'>Zum Konfigurator</button>
            </div>
          </div>
        </div>
      </section>
      {/* Newsletter */}
      <section id='newsletter'>
        <div className='title px-2'>
          <h2 className=''>Newsletter</h2>
          <p>Abonnieren Sie den kostenlosten Newsletter!</p>
        </div>
        <div className='newsletter-input'>
          <input type='email' name='email' placeholder='E-Mail-Adresse eingeben…' id='email' />
          <button className=''>Abonnieren</button>
        </div>
      </section>
      {/* Footer */}
      <Footer />
      {/* setting */}
      <Settings />
    </div>
  );
};

export default Homepage;
